export default {
    web_hooks_id: 'ID',
    web_hooks_name: 'Name',
    web_hooks_action: 'Url',
    web_hooks_event_type: 'Event Type',
    web_hooks_status: 'Status',
    web_hooks_status_active: 'Active',
    web_hooks_status_inactive: 'Inactive',
    web_hooks_created_on: 'Created On',
    web_hooks_updated_on: 'Updated On',
    web_hooks_edit: 'Edit',
    web_hooks_delete: 'Delete',
    web_hooks_add_new: 'Add New Webhook',
};
